import React, { Component } from 'react';

import './App.css';
import './components/css/Responsive.css';



import PageHeader from './components/PageHeader'
import FormIntro from './components/FormIntro'
import UserForm from './components/UserForm'
import Footer from './components/Footer'

class App extends Component{
  componentDidMount() {
    document.title = 'Movie Bloggers Network';
  }

  render(){
    return (
      <div className="App"> 
        <div className="App-container">
          
          <FormIntro />
          <UserForm />
          <Footer /> 
            
              
            </div>
        </div>
   
    );
  }
  
}

export default App;
